import { createElement } from 'react';
import { CapsuleChart } from '@jiaminghi/data-view-react';
const DataVCapsuleChart = (props) => {
    const { style, ...rest } = props;
    return createElement(CapsuleChart, { config: rest, style: style });
};
export default DataVCapsuleChart;
